// extracted by mini-css-extract-plugin
export default {"profile_navigator":"ProfileNavigator_profile_navigator__XeF0N","active":"ProfileNavigator_active__OwahU"};